import "./ContextAnswerPill.css";
import { MaterialSymbol } from "@ui/MaterialSymbol";
import { Tooltip, TooltipTrigger } from "@ui/Tooltip";
import { Text } from "@ui/typography/Text.tsx";

export type ContextAnswer = {
	title: string;
	/** Tooltip copy, as in the ask box's context row. */
	description?: string;
};

type Props = {
	answer: ContextAnswer;
};

/**
 * The saved answer a question was asked with as its context, inline in the
 * asked question beside any video mentions (see {@link VideoMentionPill}).
 */
export const ContextAnswerPill = (props: Props) => {
	return (
		<TooltipTrigger
			class="context-answer-pill-trigger"
			disabled={!props.answer.description}
			placement="top"
		>
			<span class="context-answer-pill">
				<MaterialSymbol
					symbol="auto_awesome"
					filled
					color="purple"
					relativeSize={0.9}
					aria-hidden
				/>
				<Text
					as="span"
					class="context-answer-pill__label"
					size="small"
					color="purple"
					ellipsis
				>
					{props.answer.title}
				</Text>
			</span>
			<Tooltip width="wide">{props.answer.description}</Tooltip>
		</TooltipTrigger>
	);
};
